import { api, API_BASE_URL } from './client';

// Forms API
export interface FormField {
  id: string;
  label: string;
  type: 'text' | 'date' | 'select' | 'number' | 'textarea';
  options?: string[];
  required?: boolean;
}

export interface Form {
  id: string;
  project_id: string;
  name: string;
  description?: string;
  fields: FormField[];
  field_mappings: Record<string, string>;
  is_active: boolean;
  submit_count: number;
  created_by: string;
  creator_name?: string;
  created_at: string;
  updated_at: string;
}

export interface FormSubmission {
  id: string;
  form_id: string;
  data: Record<string, unknown>;
  task_id?: string;
  task_title?: string;
  task_status?: string;
  submitter_name?: string;
  submitter_email?: string;
  created_at: string;
}

export const formsApi = {
  getByProject: (projectId: string) => api.get<{ forms: Form[] }>(`/forms/project/${projectId}`),

  getById: (id: string) => api.get<{ form: Form }>(`/forms/${id}`),

  create: (data: {
    project_id: string;
    name: string;
    description?: string;
    fields: FormField[];
    field_mappings: Record<string, string>;
  }) => api.post<{ form: Form }>('/forms', data),

  update: (id: string, data: Partial<Form>) => api.patch<{ form: Form }>(`/forms/${id}`, data),

  delete: (id: string) => api.delete<{ message: string }>(`/forms/${id}`),

  getSubmissions: (id: string, params?: { limit?: number; page?: number }) =>
    api.get<{ submissions: FormSubmission[]; total: number }>(`/forms/${id}/submissions`, params),

  // Public submit (no auth)
  submitPublic: async (formId: string, data: Record<string, unknown>) => {
    const res = await fetch(`${API_BASE_URL}/forms/public/${formId}/submit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({ error: 'Submission failed' }));
      throw new Error((err as { error: string }).error || 'Submission failed');
    }
    return res.json();
  },
};
